<template>
  <!-- CAMPAIGN -->
  <!-- Check if project is fetched from api before displaying content, to ensure proper project colouring (crowd or rais) -->
  <div v-if="project.id" class="container mb-30 campaign">
    <div class="row">
      <div class="col-md-3">
        <div :class="'campaign-text-' + crowdOrRais">
          <router-link to='/crowdfunding' class="category">{{ project.category.name }}</router-link><br>
          <span class="title">{{ project.title }}</span></br>
          <router-link v-if="project.user.id" :to="{ name: 'show_profile', params: { id: project.user.id } }" class="author">
            {{ project.user.full_name }}
          </router-link>
          <p class="short-desc">{{ project.description }}</p>
        </div><!-- .campaign-text -->
        <div v-if="project.owner && isEditable" :class="'campaign-right-' + crowdOrRais">
          <router-link :to="{ name: editRoute, params: { id: project.id }}">
            <button type="button" class="btn btn-default btn-lg button-wide">{{ $t('edit') }}</button>
          </router-link>
          <button @click="showModal = true" type="button" class="btn btn-danger btn-lg" style="background: #d43f3a; width:100%; margin-top:10px">Usuń</button>
        </div>
      </div><!-- .col-md-3 -->
      <div class="col-md-6">
        <div class="campaign-photo">
          <img v-if="project.photo.url" :src="$server_url + project.photo.url">
          <img v-else src="~assets/img/projectPlaceholder.png">
        </div><!-- .campaign-photo -->
      </div><!-- .col-md-6 -->
      <div class="col-md-3">
        <div :class="'campaign-right-' + crowdOrRais">
          <strong v-if="project.crowdfunding">CROWDFUNDING</strong>
          <strong v-else>FUNDRAISING</strong>
          <p class="allready-raised">
            {{ project.currency | currencySymbol }} {{ project.collected | price }} / {{ project.to_collect * 100 | price }}
          </p>
          <div class="bar-goal">
            <div class="bar-raised" :style="{ width: completion + '%' }"></div>
          </div>
          <div class="mb-30">
            <div class="goal-percent">{{ completion }}%</div>
            <div v-if="project.deadline" class="days-left">{{ project.deadline | daysLeft }} {{ $t('project.daysLeft') }}</div>
            <div v-else class="days-left">{{ project.duration }} {{ $t('project.daysLeft') }}</div>
          </div>
          <form v-if="!project.crowdfunding">
            <input v-model="contribution.amount" type="number" class="form-control" placeholder="$5 $20 $50">
            <reward :amount='contribution.amount' :project="project"></reward>
            <!-- <button @click="contribute()" type="button" class="btn btn-default btn-lg button-wide">{{ $t("project.show.contributeButton") }}</button> -->
          </form>
        </div><!-- .campaign-right-crowd -->
      </div><!-- .col-md-3 -->
    </div><!-- .row -->
    <div class="row mt-20">
      <div class="col-md-6 col-md-offset-3">
        <p>
          <a v-if='project.facebook' :href="'https://' + project.facebook.replace(/(^\w+:|^)\/\//, '')" title="Facebook">
            <i class="fa fa-facebook-square fa-3x"></i>
          </a>
          <a v-if='project.twitter' :href="'https://' + project.twitter.replace(/(^\w+:|^)\/\//, '')" title="Twitter">
            <i class="fa fa-twitter-square fa-3x"></i>
          </a>
          <a v-if='project.google' :href="'https://' + project.google.replace(/(^\w+:|^)\/\//, '')" title="Google +">
            <i class="fa fa-google-plus-square fa-3x"></i>
          </a>
          <a v-if='project.youtube' :href="'https://' + project.youtube.replace(/(^\w+:|^)\/\//, '')" title="YouTube"><i class="fa fa-youtube-square fa-3x"></i></a>
          <a v-if='project.custom_link' :href="'https://' + project.custom_link.replace(/(^\w+:|^)\/\//, '')" title="YourWebsite +"><i class="fa fa-globe fa-3x"></i></a>
        </p>
      </div><!-- .col-md-6 -->
    </div><!-- .row -->

    <remove-project :project="project" :show="showModal" :close="closeConfirmationModal"></remove-project>

  </div><!-- .container mb-30 campaign -->
</template>

<script>
// API
import contributionsApi from '@/api/v1/contributions';
// Components
import RemoveProject from '@/components/Project/Remove';
import Reward from '@/components/Reward/Contribute';

export default {
  props: ['project'],
  components: { RemoveProject, Reward },
  data() {
    return {
      showModal: false,
      contribution: {},
    };
  },
  methods: {
    contribute() {
      contributionsApi.new(this.project.id, this.contribution).then((response) => {
        this.project.collected += response.data.amount;
      });
    },
    closeConfirmationModal() {
      this.showModal = false;
    },
  },
  computed: {
    isEditable() {
      const status = this.project.status;
      return status === 'created' || status === 'pending' || status === 'approved';
    },
    crowdOrRais() {
      return this.project.crowdfunding ? 'crowd' : 'rais';
    },
    editRoute() {
      return this.project.crowdfunding ? 'edit_crowdfunding' : 'edit_fundraising';
    },
    completion() {
      return Math.round((this.project.collected / (this.project.to_collect * 100)) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Basic.vue?05468fb6